import {createAction, props} from "@ngrx/store";
import {Building} from "../../models/Building";

export const UPDATE = '[Buildings] Update';
export const REFRESH = '[Buildings] Refresh';
export const REFRESH_ONE_BUILDING = '[REFRESH_ONE_BUILDING] Refresh';
export const update = createAction(UPDATE, props<{ buildings: Building[] }>());
export const refresh = createAction(REFRESH);
export const refreshOneBuilding = createAction(REFRESH_ONE_BUILDING, props<{ buildingId: number }>());
